import { ArticleParagraph1, IconSuccess16, TColors } from '@cian/ui-kit';
import React from 'react';

import * as styles from './styles.css';

export const CheckmarkBulletPoint: React.FC<{ children: string; checkmarkColor: TColors }> = props => {
  return (
    <li className={styles['li']}>
      <IconSuccess16 color={props.checkmarkColor} />
      <ArticleParagraph1>{props.children}</ArticleParagraph1>
    </li>
  );
};
